import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChipTypeService, ChipType } from '../../../services/rest/chip-type.service';
import { AuthUtils } from '../../../utils/AuthUtils';
import { PermissionTargetEnum } from '../../../enums/PermissionTargetEnum';
import { InputButtonIconType } from '../../core/button/button.utils';
import { ConfirmService } from '../../../services/confirm.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-chip-type-table',
  templateUrl: './chip-type-table.component.html',
  styleUrls: ['./chip-type-table.component.scss'],
})
export class ChipTypeTableComponent implements OnInit {
  InputButtonIconType = InputButtonIconType;
  chipTypes: ChipType[] = [];
  loading = true;
  userCanEdit: boolean = AuthUtils.canEdit(PermissionTargetEnum.CHIP_TYPE);

  constructor(
    private service: ChipTypeService,
    private router: Router,
    private confirmService: ConfirmService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.getAll().subscribe((res) => {
      this.chipTypes = res;
      this.loading = false;
    });
  }

  onCreate(): void {
    this.router.navigate(['/chip-type/create']);
  }

  onEdit(item: ChipType): void {
    this.router.navigate(['/chip-type/' + item.id]);
  }

  onDelete(item: ChipType): void {
    this.confirmService.confirm(
      'Chip-Typ löschen',
      `Wollen Sie den Chip-Typ ${item.name} (${item.code}) wirklich löschen?`,
      () => {
        this.service.delete(item.id!).subscribe(() => {
          this.messageService.addSuccessMessage('Chip-Typ erfolgreich gelöscht');
          this.load();
        });
      }
    );
  }
}
